export const education = [
    {
        school: 'Amsterdam University of Applied Sciences',
        degree: "Bachelor's Degree in Computer Science and Engineering",
        period: 'September 2022 - July 2026',
        location: 'Amsterdam, North Holland, Netherlands',
        points: [
            'Studied C++ and advanced computer science topics',
            'Demonstrated responsibility',
            'Developed 8+ relevant skills'
        ]
    },
    {
        school: 'Havo de Hof',
        degree: 'Higher General Secondary Education (HAVO)',
        period: 'July 2018 - June 2022',
        points: [
            'Profile: Economics and Society (Economie en Maatschappij)',
            'Subjects: Business Economics, Geography, History, and Economics'
        ]
    }
];
